import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Ref } from 'vue-property-decorator';
import { INJECT_UICORE_BUS, INJECT_UICORE_DESIGNER } from "../../../lib/utils/consts";
import { getPopupPosition } from "../../../lib/utils/styling";
import * as styles from "./SkeletonStyleDialog.module.css";
import MarkdownForTooltip from "../../../lib/comps/MarkdownForTooltip";
import UcWindow from "../../../lib/UcWindow";
import { syncExpressionErrorVerbose } from "../../../lib/utils/script/evalRuntime";
const categories = ['编辑体验', '画布', '左面板', '属性配置', '样式配置', '行为配置', '工具栏'];
/** 两个开关 控制CompSkeleton线框的显隐 (这个弹窗感觉还能封装一层 俩开关写了这么多 */
let SkeletonStyleDialog = class SkeletonStyleDialog extends Vue {
  constructor() {
    super(...arguments);
    this.filterText = '';
    this.shown = false;
    this.left = '0px';
    this.top = '0px';
    this.width = '480px';
    this.internalIgnoreErrorComp = false;
  }
  render() {
    const h = arguments[0];
    if (!this.shown) return null; // 解脱 computed 依赖
    return h("div", [h("uc-window", {
      "attrs": {
        "left": this.left,
        "top": this.top,
        "width": this.width,
        "title": '编辑器设置',
        "visible": true
      },
      "on": {
        "close": this.cancel
      }
    }, [h("div", {
      "class": styles.filterInputBoxWrapper
    }, [h("div", {
      "class": styles.filterInputBoxIcon
    }, [h("i", {
      "class": "fa fa-filter"
    })]), h("input", _mergeJSXProps([{
      "on": {
        "input": $event => {
          if ($event.target.composing) return;
          this.filterText = $event.target.value;
        }
      },
      "class": 'uc-inputbox',
      "ref": "filterInputBox",
      "domProps": {
        "value": this.filterText
      }
    }, {
      directives: [{
        name: "model",
        value: this.filterText,
        modifiers: {}
      }]
    }]))]), h("div", {
      "class": styles.optionList
    }, [this.filteredGroupedOptions.map(({
      category,
      options
    }) => h("div", {
      "class": styles.optionCategory,
      "key": category
    }, [h("div", {
      "class": styles.optionCategorySeparator
    }), h("div", {
      "class": styles.optionCategoryTitle
    }, [category]), options.map(it => h("div", {
      "class": styles.optionItem,
      "key": it.key
    }, [!it.description ? h("div", {
      "class": styles.optionTitle
    }, [it.title]) : h("div", {
      "class": styles.optionTitle
    }, [h("a-tooltip", [h("markdown-for-tooltip", {
      "slot": "title",
      "attrs": {
        "source": it.description
      },
      "class": "w-formItem-tooltip-markdown w-formItem-tooltip-title"
    }), it.title, ' ', h("a-icon", {
      "attrs": {
        "type": "info-circle"
      },
      "class": "w-formItem-label-tooltip"
    })])]), h("div", {
      "class": styles.optionContent
    }, [it.render()])]))]))])])]);
  }
  // 历史遗留问题 反义开关给转成正常开关
  get propPanelTooltip() {
    return !this.designer.skeletonStyle.hidePropPanelTooltip;
  }
  set propPanelTooltip(value) {
    this.designer.skeletonStyle.hidePropPanelTooltip = !value;
  }
  get ucdToolbarBreadCrumbCompId() {
    return !this.designer.skeletonStyle.UcdToolbarBreadCrumbHideCompId;
  }
  set ucdToolbarBreadCrumbCompId(value) {
    this.designer.skeletonStyle.UcdToolbarBreadCrumbHideCompId = !value;
  }
  get triggersToolbarWidget() {
    return !this.designer.skeletonStyle.hideTriggersToolbarWidget;
  }
  set triggersToolbarWidget(value) {
    this.designer.skeletonStyle.hideTriggersToolbarWidget = !value;
  }
  get ignoreErrorComp() {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    this.internalIgnoreErrorComp;
    return !!localStorage.getItem('uicore:ignoreErrorComp');
  }
  set ignoreErrorComp(value) {
    this.internalIgnoreErrorComp = value;
    localStorage.setItem('uicore:ignoreErrorComp', value ? '1' : '');
  }
  get options() {
    const h = this.$createElement;
    const raw = [{
      title: '组件错误红色虚线',
      keywords: 'layout error ',
      category: '画布',
      render: () => h("a-switch", {
        "model": {
          value: this.designer.skeletonStyle.showError,
          callback: $$v => {
            this.$set(this.designer.skeletonStyle, "showError", $$v);
          }
        }
      })
    }, {
      title: '条件容器蓝色虚线',
      category: '画布',
      render: () => h("a-switch", {
        "model": {
          value: this.designer.skeletonStyle.showDisplayCondition,
          callback: $$v => {
            this.$set(this.designer.skeletonStyle, "showDisplayCondition", $$v);
          }
        }
      })
    }, {
      title: '编辑器底部留空',
      category: '画布',
      render: () => h("a-switch", {
        "model": {
          value: this.designer.zoomFitState.editZoneBottomMargin,
          callback: $$v => {
            this.$set(this.designer.zoomFitState, "editZoneBottomMargin", $$v);
          }
        }
      })
    }, {
      title: '忽略出错的组件(提高编辑时性能)',
      keywords: 'ignore error comp',
      category: '画布',
      render: () => h("a-switch", {
        "model": {
          value: this.ignoreErrorComp,
          callback: $$v => {
            this.ignoreErrorComp = $$v;
          }
        }
      })
    }, {
      title: '面包屑英文id',
      category: '工具栏',
      render: () => h("a-switch", {
        "model": {
          value: this.ucdToolbarBreadCrumbCompId,
          callback: $$v => {
            this.ucdToolbarBreadCrumbCompId = $$v;
          }
        }
      })
    }, {
      title: '工具栏触发器设置',
      category: '工具栏',
      render: () => h("a-switch", {
        "model": {
          value: this.triggersToolbarWidget,
          callback: $$v => {
            this.triggersToolbarWidget = $$v;
          }
        }
      })
    }, {
      title: '左面板自动清空输入框',
      category: '左面板',
      render: () => h("a-switch", {
        "model": {
          value: this.designer.skeletonStyle.clearSearchInputWhenSwitchLeftPanel,
          callback: $$v => {
            this.$set(this.designer.skeletonStyle, "clearSearchInputWhenSwitchLeftPanel", $$v);
          }
        }
      })
    }, {
      title: '属性面板的tooltip',
      category: '属性配置',
      render: () => h("a-switch", {
        "model": {
          value: this.propPanelTooltip,
          callback: $$v => {
            this.propPanelTooltip = $$v;
          }
        }
      })
    }, {
      title: '记住侧面板的折叠状态',
      category: '属性配置',
      render: () => h("a-switch", {
        "model": {
          value: this.designer.skeletonStyle.saveAsideExpandState,
          callback: $$v => {
            this.$set(this.designer.skeletonStyle, "saveAsideExpandState", $$v);
          }
        }
      })
    }, {
      title: '展示组件demo图',
      category: '左面板',
      render: () => h("a-switch", {
        "model": {
          value: this.designer.displayComponentDemo,
          callback: $$v => {
            this.$set(this.designer, "displayComponentDemo", $$v);
          }
        }
      })
    }, {
      title: '绑定数据时，自动更新表单项标题',
      category: '编辑体验',
      keywords: 'formItem AutoSyncTitle label',
      render: () => h("a-switch", {
        "model": {
          value: this.designer.designerConfig.formItemAutoSyncTitle,
          callback: $$v => {
            this.$set(this.designer.designerConfig, "formItemAutoSyncTitle", $$v);
          }
        }
      })
    }, {
      title: '输出脚本错误到浏览器',
      category: '编辑体验',
      keywords: 'error script console output',
      description: ['开启后，浏览器的DevTool里可能会输出大量报错。\n', '### 断点功能说明\n', '在这个模式下，脚本输出错误时，会附带形如 `ucToggleBreakpoint(...)` 的断点开启/关闭方法。', '你可以运行它开启断点，然后，再次执行函数或者表达式时，会进入暂停状态。\n', this.uc.config.docLink.ucToggleBreakpoint ? `[点击查看文档](${this.uc.config.docLink.ucToggleBreakpoint})` : '详询平台开发者'].join('\n'),
      render: () => h("select", {
        "domProps": {
          "value": localStorage.getItem('uicore:expressionErrorVerbose') || ''
        },
        "style": "width: auto",
        "class": "uc-inputbox",
        "on": {
          "change": this.handleExpressionErrorVerboseChange
        }
      }, [h("option", {
        "attrs": {
          "value": ""
        }
      }, ["\u4E0D\u8F93\u51FA"]), h("option", {
        "attrs": {
          "value": "1"
        }
      }, ["\u8F93\u51FA"]), h("option", {
        "attrs": {
          "value": "2"
        }
      }, ["\u8F93\u51FA+\u652F\u6301\u65AD\u70B9(\u6162)"])])
    }, {
      title: '路径记录个数',
      category: '编辑体验',
      keywords: 'path history',
      description: '记录选中过的组件的路径的个数，超过这个数目后，会自动删除最早的记录',
      render: () => h("a-input-number", {
        "attrs": {
          "value": this.designer.compPathHistoryMaxNum
        },
        "on": {
          "change": value => {
            this.designer.compPathHistoryMaxNum = value;
            localStorage.setItem('uicore:compPathHistory', value);
          }
        }
      })
    }];
    return raw.map((it, index) => ({
      ...it,
      key: `opt-${index}`,
      keywords: [it.keywords || '', it.title, it.description].join('\n').toLowerCase()
    }));
  }
  get filteredGroupedOptions() {
    const {
      options,
      filterText
    } = this;
    const keys = filterText.split(/[-\s,.，_]+/).filter(Boolean).map(str => str.toLowerCase());
    const filteredOptions = !keys.length ? options : options.filter(x => keys.every(key => x.keywords.includes(key)));
    const grouped = categories.map(category => ({
      category,
      options: filteredOptions.filter(x => x.category === category)
    })).filter(it => it.options.length);
    return grouped;
  }
  handleExpressionErrorVerboseChange(ev) {
    localStorage.setItem('uicore:expressionErrorVerbose', ev.target.value);
    syncExpressionErrorVerbose();
    this.uc.$message.success('错误输出偏好已更新，建议刷新一下页面');
  }
  cancel() {
    var _this$respondAndClose;
    (_this$respondAndClose = this.respondAndClose) === null || _this$respondAndClose === void 0 || _this$respondAndClose.call(this);
  }
  show(opt) {
    return new Promise(resolve => {
      var _opt$filterText;
      const position = getPopupPosition({
        anchor: opt.place || document.activeElement,
        container: this.designer.$el,
        width: parseInt(this.width, 10),
        height: 400
      });
      this.left = `${position.x}px`;
      this.top = `${position.y + 60}px`;
      this.shown = true;
      this.filterText = (_opt$filterText = opt.filterText) !== null && _opt$filterText !== void 0 ? _opt$filterText : this.filterText;
      this.$nextTick(() => {
        var _this$filterInputBox;
        (_this$filterInputBox = this.filterInputBox) === null || _this$filterInputBox === void 0 || _this$filterInputBox.focus();
      });
      this.respondAndClose = () => {
        resolve(null);
        this.shown = false;
        this.respondAndClose = undefined;
      };
    });
  }
};
__decorate([Ref()], SkeletonStyleDialog.prototype, "filterInputBox", void 0);
SkeletonStyleDialog = __decorate([Component({
  name: 'SkeletonStyleDialog',
  components: {
    UcWindow,
    MarkdownForTooltip
  },
  inject: {
    uc: {
      from: INJECT_UICORE_BUS
    },
    designer: {
      from: INJECT_UICORE_DESIGNER
    }
  }
})], SkeletonStyleDialog);
export default SkeletonStyleDialog;
//# sourceMappingURL=SkeletonStyleDialog.js.map
